export class Message {
    content: string;
    timestamp: Date;
    avatar: string;
    client: boolean;
    system: boolean;
    participantID: string;
    seqConversation: number;
    sequence: number;

    constructor(content: string, avatar: string, participantID: string, timestamp?: Date, client?: boolean,
                system?: boolean, seqConversation?: number, sequence?: number) {
        this.content = content;
        this.timestamp = timestamp;
        this.avatar = avatar;
        this.client = client;
        this.system = system;
        this.participantID = participantID;
        this.seqConversation = seqConversation;
        this.sequence = sequence;
  }
}
